module.exports = __webpack_public_path__ + "static/img/icon010.eff4157b.svg";